import { T } from './Translate';
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect, useState, useCallback, useMemo, useRef } from "react";
import useInfiniteScroll, { FEED_PAGE_SIZE } from "../hooks/useInfiniteScroll";
import { usePagedFeed, useEnsureFeedCount, feedMayHaveMore } from "../hooks/usePagedFeed";
import { getCouponStatus } from "../components/CouponExpiryFields";
import SaleEventsCountdown from "../components/SaleEventsCountdown";
import {
  Container,
  AppBar,
  Toolbar,
  CardMedia,
  IconButton,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  CircularProgress,
  DialogContentText,
  TextField,
  Divider,
  Paper,
  Collapse,
  Avatar,
  Skeleton,
  useMediaQuery,
  Chip,
  Drawer,
  Slider,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  Menu,
  InputLabel,
  FormControl,
} from "@mui/material";
import { MoreVert as MoreVertIcon } from "../icons";
import { Share as ShareIcon } from "../icons";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { Search as SearchIcon } from "../icons";
import { ThumbUpAlt as ThumbUpAltIcon } from "../icons";
import { Link, useSearchParams } from "react-router-dom";
import { blockUser, unblockUser, fetchBlockedIds } from "../utils/blockedUsers";
import { useNavigate } from "react-router-dom";
import CopyToClipboardComponent from "./CopyToClipboardButton";
import { isLoggedIn } from "../session";
import { auth } from "../firebase";
import logoSvg from "../imgs/logo.png";
import { barColors, brandColors } from "../theme";
import { alpha } from "@mui/material/styles";
import InterestButton from "../components/InterestButton";
import themeService from "../services/themeService";
import { ArrowBackIos as ArrowBackIosIcon } from "../icons";
import { ArrowForwardIos as ArrowForwardIosIcon } from "../icons";
import ScrollAwareVideo from "../components/ScrollAwareVideo";
import BottomToolbar from "./BottomToolbar";
import { useGeolocation } from "../hooks/useGeolocation";
import {
  formatDate,
  getDomainFromUrl,
  handleMeSirve,
  mapOfferDoc,
  getCountryFromCoordinates,
  fetchUserLikes,
  fetchFollowing,
  handleFollow,
  fetchQuestionsAndAnswers,
  postQuestion,
  postAnswer,
  fetchAnswers,
  fetchQuestionsAndAnswersWithUserData,
  calculateOfferScore,
  toggleSaveOffer,
  fetchSavedOfferIds,
  fetchVerifiedUids,
  fetchOfficialUids,
  hideOffer,
  fetchHiddenOfferIds,
  reportItem,
  unfollowCompany,
  formatCount,
} from "./homeUtils";
import CustomToolbar from "./CustomToolbar";
import { LocalOffer as LocalOfferIcon } from "../icons";
import { Close as CloseIcon } from "../icons";
import { Bookmark as BookmarkIcon } from "../icons";
import { BookmarkBorder as BookmarkBorderIcon } from "../icons";
import { ExpandMore as ExpandMoreIcon } from "../icons";
import { ExpandLess as ExpandLessIcon } from "../icons";
import { ForumOutlined as ForumOutlinedIcon } from "../icons";
import { Send as SendIcon } from "../icons";
import { Star as StarIcon } from "../icons";
import { pageContentSx, PAGE_CONTENT_MAX_WIDTH, FILTER_PANEL_BOTTOM_GAP, filterPanelScrollSx, feedPostSx, feedPostHeaderSx, feedPostBodySx, feedPostMediaRadius, feedPostTextPx } from "../pageLayout";
import { useDesktopSidebar } from "../desktopSidebarContext";
import DiscountPriceBreakdown from "../components/DiscountPriceBreakdown";
import FollowItemButton, { FollowItemCountdown } from "../components/FollowItemButton";
import OfferBuyButton from "../components/OfferBuyButton";
import OfferPaymentBadges from "../components/OfferPaymentBadges";
import VerifiedBadge from "./VerifiedBadge";
import OfficialBadge from "./OfficialBadge";
import useAuthorPhotos from "./useAuthorPhotos";
import SheetDragHandle from "../components/SheetDragHandle";
import { OFFER_CATEGORIES } from "../offerCategories";

import SearchClearAdornment from "../components/SearchClearAdornment";
// logo.png es texto blanco sobre fondo navy sólido (para el AppBar oscuro de
// siempre); en Modo Claro ese fondo pasa a blanco (ver barColors más abajo)
// y ese logo quedaría invisible ahí, así que se usa la versión con texto
// oscuro (public/logo1.png, fondo transparente) en su lugar. themeService no
// es reactivo (cambiar de tema recarga la página, ver ajustes.js), así que
// leer el modo una vez alcanza.
const LIGHT_LOGO_URL = `${process.env.PUBLIC_URL}/logo1.png`;
const DARK_LOGO_URL = `${process.env.PUBLIC_URL}/logo5.png`;
const isLightTheme = themeService.getResolvedMode() === "light";
const isDarkTheme = themeService.getResolvedMode() === "dark";

const Home = () => {
  // El feed (980) queda centrado en la página de verdad (no el bloque
  // sidebar+feed): la sidebar (260+24) se compensa con una columna espejo
  // invisible del mismo ancho del otro lado, así que hace falta
  // 260+24+980+24+260 = 1568px + padding lateral para que entre sin recortarse.
  // noSsr: sin esto MUI devuelve false en el primer render y recién después el
  // valor real, así que en desktop se pintaba el layout mobile y luego saltaba (CLS).
  const sidebarActive = useDesktopSidebar();
  // Con la sidebar de escritorio (240px) el layout ancho necesita ese lugar de más.
  const isDesktop = useMediaQuery(sidebarActive ? '(min-width:1840px)' : '(min-width:1600px)', { noSsr: true });
  // Con la sidebar el logo y las categorías viven en ella: el AppBar solo
  // queda (plano) para los íconos de buscar/filtros cuando no hay panel lateral.
  const showTopBar = !sidebarActive || !isDesktop;

  const [loading, setLoading] = useState(false);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [userLikes, setUserLikes] = useState({});
  const [offers, setOffers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [openImageModal, setOpenImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [questions, setQuestions] = useState({});
  const [newQuestion, setNewQuestion] = useState({});
  const [newAnswer, setNewAnswer] = useState({});
  const [answers, setAnswers] = useState({});
  const [showMoreQuestions, setShowMoreQuestions] = useState({});
  const [showQA, setShowQA] = useState({});
  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] = useState(null);
  const [optionsMenuOffer, setOptionsMenuOffer] = useState(null);
  const [questionsAndAnswers, setQuestionsAndAnswers] = useState({});
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [aspectRatio, setAspectRatio] = useState("9:16");
  const [savedOfferIds, setSavedOfferIds] = useState([]);
  const [verifiedUids, setVerifiedUids] = useState([]);
  const [officialUids, setOfficialUids] = useState([]);
  const [hiddenOfferIds, setHiddenOfferIds] = useState([]);
  const [blockedIds, setBlockedIds] = useState([]);
  const [filterSavedOnly, setFilterSavedOnly] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [sortBy, setSortBy] = useState("relevancia");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [discountRange, setDiscountRange] = useState([0, 100]);
  const [filterMostSold, setFilterMostSold] = useState(false);
  const [filterFollowedOnly, setFilterFollowedOnly] = useState(false);
  const [priceRange, setPriceRange] = useState({ min: "", max: "" });
  const [highlightedOfferId, setHighlightedOfferId] = useState(null);

  const answerInputRef = useRef({});
  const searchTimeout = useRef(null);
  // Ofertas con un toggle de "Me Interesa" en curso: evita que un doble
  // click/tap dispare la transacción dos veces mientras la primera todavía
  // no terminó (ver handleMeSirve en homeUtils.js).
  const pendingLikeOfferIds = useRef(new Set());
  const appBarRef = useRef(null);
  const [appBarHeight, setAppBarHeight] = useState(144);
  const [searchBarHidden, setSearchBarHidden] = useState(false);
  const lastScrollY = useRef(0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Mide el alto real del AppBar fijo (logo + categorías +, en mobile, la
  // barra de búsqueda/filtro) en vez de adivinar un valor en px: así el
  // contenido de abajo arranca pegado sin gap ni superposición sin importar
  // cuánto mida cada fila (cambia según breakpoint, tema, si el buscador
  // está abierto, etc).
  useLayoutEffect(() => {
    const node = appBarRef.current;
    if (!node) {
      setAppBarHeight(0);
      return;
    }
    const updateHeight = () => setAppBarHeight(node.offsetHeight);
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(node);
    return () => observer.disconnect();
  }, [isDesktop, isSearchOpen, showTopBar]);

  // Oculta la barra de búsqueda/filtro al scrollear hacia abajo (mobile) para
  // que el header ocupe menos lugar mientras se navega el feed, y la vuelve
  // a mostrar al subir. No se oculta con el buscador abierto para no perder
  // el foco del input a mitad de una búsqueda.
  useEffect(() => {
    if (isDesktop) return undefined;
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (isSearchOpen) {
        setSearchBarHidden(false);
      } else if (currentY > lastScrollY.current && currentY > 80) {
        setSearchBarHidden(true);
      } else {
        setSearchBarHidden(false);
      }
      lastScrollY.current = currentY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDesktop, isSearchOpen]);

  const { position: coordinates } = useGeolocation();
  const [detectedCountry, setDetectedCountry] = useState(null);

  // Ofertas de a tandas desde Firestore (ver usePagedFeed): antes se
  // escuchaba la colección entera. El filtrado y el orden por relevancia se
  // aplican sobre lo ya cargado.
  const offersFeed = usePagedFeed("offers", mapOfferDoc);
  const rawOffers = offersFeed.items;
  const offersLoading = offersFeed.loading;

  // Deep link desde otras pantallas (ej. members.js) a una publicación
  // puntual: /home?highlight=<offerId> scrollea hasta esa card y la resalta
  // un momento para que se note cuál es.
  useEffect(() => {
    const highlight = searchParams.get("highlight");
    if (!highlight || offersLoading || rawOffers.length === 0) return;
    const target = document.getElementById(`offer-${highlight}`);
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    setHighlightedOfferId(highlight);
    const timeout = setTimeout(() => setHighlightedOfferId(null), 2500);
    return () => clearTimeout(timeout);
  }, [searchParams, offersLoading, rawOffers]);

  // Mismo criterio que events.js: el país se detecta una sola vez cuando
  // llegan las coordenadas, en vez de volver a consultar la API de reverse
  // geocoding cada vez que cambia un filtro. Antes esto vivía adentro del
  // efecto que arma filteredOffers, así que cada cambio de discountRange
  // (incluso arrastrando el slider) disparaba un fetch nuevo, y las
  // respuestas podían llegar desordenadas y pisarse entre sí: el listado
  // parpadeaba entre "resultados" y "sin resultados" (loop de encontrar/no
  // encontrar) mientras las respuestas viejas sobreescribían a las nuevas.
  useEffect(() => {
    if (coordinates?.latitude && coordinates?.longitude) {
      getCountryFromCoordinates(coordinates.latitude, coordinates.longitude).then(
        setDetectedCountry
      );
    }
  }, [coordinates]);

  useEffect(() => {
    if (auth.currentUser) {
        fetchFollowing(setFollowing, setLoading);
    } else {
        setFollowing([]);
    }
  }, [auth.currentUser]);

  useEffect(() => {
    const checkAuthAndRequestPermission = async () => {
      const loggedIn = await isLoggedIn();
      setUserAuthenticated(loggedIn);
    };
    checkAuthAndRequestPermission();
  }, []);

  useEffect(() => {
    if (userAuthenticated && auth.currentUser) {
      fetchUserLikes(userAuthenticated, setUserLikes);
      fetchSavedOfferIds(auth.currentUser.uid).then(setSavedOfferIds);
      fetchVerifiedUids().then(setVerifiedUids);
      fetchOfficialUids().then(setOfficialUids);
      fetchHiddenOfferIds(auth.currentUser.uid).then(setHiddenOfferIds);
      fetchBlockedIds(auth.currentUser.uid).then(setBlockedIds);
    } else {
        setUserLikes({});
        setSavedOfferIds([]);
        setVerifiedUids([]);
        setHiddenOfferIds([]);
        setBlockedIds([]);
    }
  }, [userAuthenticated]);


  // Ofertas con cupón vencido por fecha: se ocultan en el momento en que su
  // temporizador llega a 0 (la función deleteExpiredCouponOffers las borra
  // después de la base). couponClock avanza justo al próximo vencimiento para
  // que filteredOffers se recalcule sin tener que recargar.
  const [couponClock, setCouponClock] = useState(() => Date.now());
  useEffect(() => {
    const upcoming = rawOffers
      .map((offer) => offer.cuponExpiresAt && new Date(`${offer.cuponExpiresAt}T23:59:59`).getTime())
      .filter((t) => t && t > couponClock);
    if (upcoming.length === 0) return undefined;
    // setTimeout no acepta más de ~24 días: si falta más, reprograma.
    const delay = Math.min(Math.min(...upcoming) - Date.now() + 1000, 2 ** 31 - 1);
    const id = setTimeout(() => setCouponClock(Date.now()), Math.max(delay, 0));
    return () => clearTimeout(id);
  }, [rawOffers, couponClock]);

  // Mismo criterio que renderEventList en events.js: todo el filtrado y
  // ordenamiento se calcula de forma síncrona en un useMemo a partir de
  // rawOffers, en vez de ir armando filteredOffers a los saltos dentro de un
  // useEffect con pasos async en el medio (eso era la causa del loop
  // resultados/sin-resultados al filtrar, ver detectedCountry más arriba).
  const filteredOffers = useMemo(() => {
    if (!rawOffers || rawOffers.length === 0) return [];

    const scoredOffers = rawOffers.map((offer) => ({
      ...offer,
      score: calculateOfferScore(offer, following),
    }));

    let offersToFilter = [...scoredOffers].sort((a, b) => b.score - a.score);

    offersToFilter = offersToFilter.filter(
      (offer) =>
        !hiddenOfferIds.includes(offer.id) &&
        !blockedIds.includes(offer.uid) &&
        getCouponStatus(offer) !== "expired"
    );

    if (detectedCountry) {
      // Las ofertas "worldwide" se guardan sin country (ver publishOffer.js)
      // y deben verse desde cualquier país.
      offersToFilter = offersToFilter.filter(
        (offer) => !offer.country || offer.country === detectedCountry
      );
    }

    if (filterSavedOnly) {
      offersToFilter = offersToFilter.filter((offer) => savedOfferIds.includes(offer.id));
    }

    if (filterFollowedOnly) {
      offersToFilter = offersToFilter.filter((offer) => following.includes(offer.uid));
    }

    if (filterMostSold) {
      offersToFilter = offersToFilter.filter((offer) => Number(offer.salesCount || offer.soldCount || 0) > 0);
    }

    // Las ofertas viejas sin categoría cuentan como "Otros".
    if (selectedCategory) {
      offersToFilter = offersToFilter.filter((offer) => (offer.category || "otros") === selectedCategory);
    }

    offersToFilter = offersToFilter.filter((offer) => {
      const discount = Number(offer.offer) || 0;
      return discount >= discountRange[0] && discount <= discountRange[1];
    });

    if (priceRange.min !== "") {
      offersToFilter = offersToFilter.filter((offer) => Number(offer.price) >= Number(priceRange.min));
    }
    if (priceRange.max !== "") {
      offersToFilter = offersToFilter.filter((offer) => Number(offer.price) <= Number(priceRange.max));
    }

    if (sortBy === "recientes") {
      offersToFilter = [...offersToFilter].sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : new Date(a.createdAt || 0).getTime();
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : new Date(b.createdAt || 0).getTime();
        return dateB - dateA;
      });
    } else if (sortBy === "descuento") {
      offersToFilter = [...offersToFilter].sort((a, b) => (Number(b.offer) || 0) - (Number(a.offer) || 0));
    } else if (sortBy === "interesa") {
      offersToFilter = [...offersToFilter].sort((a, b) => (Number(b.helpedCount) || 0) - (Number(a.helpedCount) || 0));
    }
    // sortBy === "relevancia" mantiene el orden por score ya calculado arriba.

    if (searchTerm.trim()) {
      const searchValue = searchTerm.toLowerCase().trim();
      offersToFilter = offersToFilter.filter(
        (offer) =>
          offer.name?.toLowerCase().includes(searchValue) ||
          (offer.title && offer.title.toLowerCase().includes(searchValue)) ||
          (offer.product && offer.product.toLowerCase().includes(searchValue))
      );
    }

    return offersToFilter;
  }, [
    rawOffers,
    following,
    detectedCountry,
    searchTerm,
    filterSavedOnly,
    savedOfferIds,
    filterFollowedOnly,
    filterMostSold,
    selectedCategory,
    discountRange,
    priceRange,
    sortBy,
    hiddenOfferIds,
    blockedIds,
    couponClock,
  ]);

  // Muestra las ofertas de a 13 y suma otras 13 al acercarse a la última.
  const { limit: offersLimit, sentinelRef: offersSentinelRef } = useInfiniteScroll(
    JSON.stringify([searchTerm, filterSavedOnly, filterFollowedOnly, filterMostSold, selectedCategory, discountRange, priceRange, sortBy]),
    FEED_PAGE_SIZE
  );
  // Con /home?highlight=<id> la oferta tiene que estar renderizada para poder
  // scrollear hasta ella aunque quede más allá de la primera tanda.
  const highlightParam = searchParams.get("highlight");
  const highlightIndex = highlightParam ? filteredOffers.findIndex((o) => o.id === highlightParam) : -1;
  const visibleOffersCount = Math.max(offersLimit, highlightIndex + 1);
  // Si el deep link apunta a una oferta que todavía no se cargó, se sigue
  // pidiendo hasta encontrarla (o hasta el final).
  useEnsureFeedCount(
    offersFeed,
    filteredOffers.length,
    highlightParam && highlightIndex < 0 ? filteredOffers.length + 1 : visibleOffersCount
  );

  const hasSearched = searchTerm.trim().length > 0;

  useEffect(() => {
    if (filteredOffers.length > 0) {
      filteredOffers.forEach((offer) => {
        if (!questionsAndAnswers[offer.id]) {
            fetchQuestionsAndAnswersWithUserData(offer.id, (fetchedData) => {
            setQuestionsAndAnswers((prevData) => ({
                ...prevData,
                [offer.id]: fetchedData,
            }));
            });
        }
      });
    }
  }, [filteredOffers]);

  const handleLoadedMetadata = (e) => {
    const video = e.target;
    const ratio = video.videoWidth / video.videoHeight;
    setAspectRatio(ratio > 1 ? "16:9" : "9:16");
  };

  const handleShareClick = (offer) => {
    if (navigator.share) {
      navigator.share({
        title: offer.product || offer.title,
        text: offer.description,
        url: `${window.location.origin}/profile/${offer.uid}`,
      }).catch(() => {});
    }
  };

  const handleMeSirveClick = useCallback(async (offerId) => {
    if (!userAuthenticated || !auth.currentUser) return;
    if (pendingLikeOfferIds.current.has(offerId)) return;
    pendingLikeOfferIds.current.add(offerId);
    try {
      await handleMeSirve(
        offerId,
        userAuthenticated,
        auth.currentUser.uid,
        // La lista se actualiza sola por onSnapshot (usePagedFeed).
        () => {},
        setUserLikes
      );
    } finally {
      pendingLikeOfferIds.current.delete(offerId);
    }
  }, [userAuthenticated]);

  const handleFollowClick = useCallback((companyId) => {
    if (!userAuthenticated || !auth.currentUser) return;
    handleFollow(
      companyId,
      auth.currentUser.uid,
      following,
      setFollowing,
      setLoading
    );
  }, [userAuthenticated, following]);

  const handleOpenOptionsMenu = useCallback((event, offer) => {
    setOptionsMenuAnchorEl(event.currentTarget);
    setOptionsMenuOffer(offer);
  }, []);

  const handleOptionsMenuClose = useCallback(() => {
    setOptionsMenuAnchorEl(null);
    setOptionsMenuOffer(null);
  }, []);

  const handleUnfollowMenuClick = useCallback((offer) => {
    if (!offer || !auth.currentUser) return;
    unfollowCompany(offer.uid, auth.currentUser.uid, setFollowing);
  }, []);

  const handleReportOffer = useCallback((offer) => {
    if (!offer || !auth.currentUser) return;
    reportItem({
      reporterId: auth.currentUser.uid,
      targetType: "offer",
      targetId: offer.id,
      companyId: offer.uid,
    });
  }, []);

  const handleHideOffer = useCallback((offer) => {
    if (!offer || !auth.currentUser) return;
    hideOffer(auth.currentUser.uid, offer.id);
    setHiddenOfferIds((prev) => (prev.includes(offer.id) ? prev : [...prev, offer.id]));
  }, []);

  const handleSimilarOffers = useCallback((offer) => {
    if (!offer) return;
    navigate(`/profile/${offer.uid}`);
  }, [navigate]);

  const handleBlockOfferUserClick = useCallback(async (offer) => {
    if (!offer || !auth.currentUser) return;
    await blockUser(auth.currentUser.uid, offer.uid);
    setBlockedIds((prev) => (prev.includes(offer.uid) ? prev : [...prev, offer.uid]));
  }, []);

  const handleUnblockOfferUserClick = useCallback(async (offer) => {
    if (!offer || !auth.currentUser) return;
    await unblockUser(auth.currentUser.uid, offer.uid);
    setBlockedIds((prev) => prev.filter((id) => id !== offer.uid));
  }, []);

  const handleToggleSaveClick = useCallback((offer) => {
    if (!offer || !auth.currentUser) return;
    const isSaved = savedOfferIds.includes(offer.id);
    toggleSaveOffer(auth.currentUser.uid, offer.id, isSaved);
    setSavedOfferIds((prev) =>
      isSaved ? prev.filter((id) => id !== offer.id) : [...prev, offer.id],
    );
  }, [savedOfferIds]);

  const handleOpenImageModal = (images) => {
    setModalImages(images);
    setCurrentImageIndex(0);
    setOpenImageModal(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === modalImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? modalImages.length - 1 : prevIndex - 1
    );
  };

  const handleQuestionSubmit = async (offerId) => {
    const questionText = newQuestion[offerId]?.trim();
    if (questionText && auth.currentUser) {
      await postQuestion(offerId, auth.currentUser.uid, questionText);
      setNewQuestion((prev) => ({ ...prev, [offerId]: "" }));
    }
  };

  const handleAnswerSubmit = async (questionId, offerId) => {
     const answerText = newAnswer[questionId]?.trim();

    if (answerText && auth.currentUser) {
      await postAnswer(
        questionId,
        auth.currentUser.uid,
        answerText,
        offerId
      );
      setNewAnswer((prevAnswers) => ({ ...prevAnswers, [questionId]: "" }));
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
  };

  const toggleSearch = () => {
    setIsSearchOpen((prev) => {
      const nextState = !prev;
      if (!nextState) {
        setSearchTerm("");
      } else {
        setTimeout(() => {
          document.getElementById("search-input")?.focus();
        }, 100);
      }
      return nextState;
    });
  };

  const isCompanyFollowed = useCallback(
    (companyId) => following.includes(companyId),
    [following]
  );

  const SkeletonOfferCard = () => (
    <ListItem sx={{ ...styles.listItem, ...feedPostSx }}>
      <Box sx={{ ...styles.contUser, ...feedPostHeaderSx }}>
        <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
        <Skeleton variant="text" width="40%" height={24} />
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>

      <Box sx={feedPostBodySx}>
        <Box sx={styles.mediaSection}>
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            sx={{ 
              paddingBottom: '56.25%',
              borderRadius: feedPostMediaRadius,
              mb: 1 
            }} 
          />
        </Box>

        <Box sx={{ ...styles.contentSection, px: feedPostTextPx, pb: { xs: 1.5, sm: 0 } }}>
          <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="30%" height={28} sx={{ borderRadius: '4px', mb: 1 }} />
          <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: '6px', mb: 1 }} />
          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <Skeleton variant="rectangular" width="50%" height={36} sx={{ borderRadius: '6px' }} />
            <Skeleton variant="rectangular" width="50%" height={36} sx={{ borderRadius: '6px' }} />
          </Box>
          <Skeleton variant="text" width="40%" height={16} />
        </Box>
      </Box>
    </ListItem>
  );

  const SkeletonLoader = () => (
      <List sx={{ padding: 0 }}>
        {[1, 2, 3].map((index) => (
          <SkeletonOfferCard key={index} />
        ))}
      </List>
  );

  const NoResults = () => (
    <Paper sx={additionalStyles.noResults}>
      <LocalOfferIcon sx={additionalStyles.noResultsIcon} />
      <Typography variant="h6"><T>No encontramos resultados</T></Typography>
      <Typography color="textSecondary">
        <T>No hay publicaciones que coincidan con</T> "{searchTerm}"
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setSearchTerm("")}
      >
        <T>Limpiar búsqueda</T>
      </Button>
    </Paper>
  );

  const authorPhotos = useAuthorPhotos(offers.map((offer) => offer.uid));

  const renderOfferList = useCallback(
    (offersList) => {
      if (!Array.isArray(offersList)) {
          console.warn("renderOfferList received non-array:", offersList);
          return null;
      }
      return (
          <List sx={{ padding: 0 }}>
            {offersList.map((offer, offerIndex) => (
              <ListItem
                key={offer.id}
                id={`offer-${offer.id}`}
                sx={{
                  ...styles.listItem,
                  ...feedPostSx,
                  transition: "box-shadow 0.3s ease, background-color 0.3s ease",
                  ...(highlightedOfferId === offer.id && {
                    boxShadow: `0 0 0 3px ${brandColors.accent}`,
                    backgroundColor: alpha(brandColors.accent, 0.08),
                    borderRadius: "8px",
                  }),
                }}
              >
                <Box sx={{ ...styles.contUser, ...feedPostHeaderSx }}>
                  <Avatar
                    src={authorPhotos[offer.uid] || offer.image}
                    alt={offer.name}
                    sx={{ width: 40, height: 40, mr: 2, flexShrink: 0, border: `2.5px solid ${brandColors.divider}` }}
                  />
                  <Link to={`/profile/${offer.uid}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 1, overflow: 'hidden' }}>
                    <Typography sx={{ ...styles.name, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{offer.name}</Typography>
                    {verifiedUids.includes(offer.uid) && <VerifiedBadge />}
                    {officialUids.includes(offer.uid) && <OfficialBadge />}
                  </Link>

                  {/* Todo lo demás (destacado, seguir, guardar, opciones) va
                      agrupado y anclado a la derecha (ml: auto en este Box):
                      el nombre ocupa el espacio libre y se trunca si hace
                      falta, en vez de que estos elementos se dispersen por
                      la fila. */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 }, ml: 'auto', flexShrink: 0 }}>
                    {offer.isPromoted && (
                      <Chip
                        icon={<StarIcon sx={{ fontSize: '9px !important', ml: '3px !important' }} />}
                        label={<T>Destacado</T>}
                        size="small"
                        sx={{
                          height: 14,
                          flexShrink: 0,
                          bgcolor: brandColors.accent,
                          color: '#fff',
                          '& .MuiChip-icon': { color: '#fff' },
                          '& .MuiChip-label': { fontSize: '0.55rem', px: '4px', fontWeight: 600 },
                        }}
                      />
                    )}

                    {!isCompanyFollowed(offer.uid) && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleFollowClick(offer.uid)}
                        disabled={loading || !userAuthenticated}
                        sx={{ flexShrink: 0, textTransform: 'none', borderColor: brandColors.primary, color: brandColors.accent }}
                      >
                        <T>Seguir</T>
                      </Button>
                    )}

                    {userAuthenticated && (
                      <IconButton
                        onClick={() => handleToggleSaveClick(offer)}
                        aria-label={savedOfferIds.includes(offer.id) ? "quitar de guardados" : "guardar"}
                        sx={{ p: { xs: 0.5, sm: 1 } }}
                      >
                        {savedOfferIds.includes(offer.id) ? <BookmarkIcon /> : <BookmarkBorderIcon />}
                      </IconButton>
                    )}

                    <FollowItemButton type="offer" item={offer} />

                    <IconButton
                      onClick={() => handleShareClick(offer)}
                      aria-label="share"
                      sx={{ p: { xs: 0.5, sm: 1 } }}
                    >
                      <ShareIcon />
                    </IconButton>

                    <IconButton
                      onClick={(e) => handleOpenOptionsMenu(e, offer)}
                      aria-label="more options"
                      sx={{ p: { xs: 0.5, sm: 1 } }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </Box>

                <Box sx={feedPostBodySx}>
                  <Box sx={styles.mediaSection}>
                    {offer.videos && offer.videos.length > 0 ? (
                      <Box
                        sx={{
                          position: 'relative',
                          width: '100%',
                          paddingBottom: aspectRatio === '16:9' ? '56.25%' : '177.78%',
                          backgroundColor: '#000',
                          borderRadius: feedPostMediaRadius,
                          overflow: 'hidden',
                          mb: 1,
                        }}
                      >
                        <ScrollAwareVideo
                          src={offer.videos[0]}
                          controls
                          playsInline
                          onLoadedMetadata={handleLoadedMetadata}
                          style={{
                            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover',
                          }}
                          // Forzar sonido habilitado
                          muted={false}
                        />
                      </Box>
                    ) : offer.images && offer.images.length > 0 ? (
                      <Box sx={{ ...styles.imageContainer, mb: 1 }}>
                        <CardMedia
                          component="img"
                          image={offer.images[0]}
                          alt={`Imagen principal de ${offer.name}`}
                          // La primera imagen del feed es el LCP: se pide con prioridad
                          // alta y el resto en diferido para que no compitan por ancho de banda.
                          loading={offerIndex === 0 ? "eager" : "lazy"}
                          fetchpriority={offerIndex === 0 ? "high" : "auto"}
                          decoding="async"
                          sx={styles.mainImage}
                          onClick={() => handleOpenImageModal(offer.images)}
                          style={{ cursor: 'pointer' }}
                        />
                        {offer.images.length > 1 && (
                          <Box
                            sx={styles.additionalImagesOverlay}
                            onClick={() => handleOpenImageModal(offer.images)}
                          >
                            <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                              +{offer.images.length - 1}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ ...styles.imageContainer, mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: brandColors.backgroundDefault, minHeight: '150px' }}>
                        <Typography variant="caption" color="textSecondary"><T>No hay imagen/video</T></Typography>
                      </Box>
                    )}
                  </Box>

                  <Box sx={{ ...styles.contentSection, px: feedPostTextPx }}>
                    {/* Link a la ficha pública: también le da a Google enlaces rastreables */}
                    <Typography component={Link} to={`/offers/${offer.id}`} sx={{ ...styles.title, ...{ color: "inherit", textDecoration: "none", display: "block", "&:hover": { textDecoration: "underline" } } }}>{offer.product || offer.title}</Typography>
                    <Typography sx={styles.description}>{offer.description}</Typography>

                    {offer.price && (
                      <DiscountPriceBreakdown
                        originalPrice={Number(offer.price)}
                        discountPercent={Number(offer.offer) || 0}
                        finalPrice={Number(offer.price) * (1 - (Number(offer.offer) || 0) / 100)}
                      />
                    )}

                    <OfferPaymentBadges offer={offer} />

                    <FollowItemCountdown type="offer" item={offer} sx={{ mb: 1 }} />

                    {offer.cupon && <CopyToClipboardComponent textToCopy={offer.cupon} offer={offer} />}

                    <OfferBuyButton offer={offer} />

                    {offer.url && (
                      <Button
                        variant="contained"
                        color="primary"
                        href={!offer.url.startsWith('http') ? `http://${offer.url}` : offer.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ ...styles.button, ...styles.actionButton, width: '100%', mt: 1, mb: 1 }}
                      >
                        <T>Comprar en</T> {getDomainFromUrl(offer.url)}
                      </Button>
                    )}

                    <InterestButton
                        liked={!!userLikes[offer.id]}
                        count={formatCount(offer.helpedCount || 0)}
                        onClick={() => handleMeSirveClick(offer.id)}
                        disabled={!userAuthenticated}
                      />

                    <Typography sx={styles.created}>
                      <T>Publicado:</T> {formatDate(offer.createdAt)}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ mt: { xs: 2, sm: 3 }, borderTop: `1px solid ${brandColors.divider}`, pt: 2, px: feedPostTextPx, pb: { xs: 1.5, sm: 0 } }}>
                  <Box
                    onClick={() => setShowQA((prev) => ({ ...prev, [offer.id]: !prev[offer.id] }))}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                  >
                    <ForumOutlinedIcon sx={{ fontSize: 20, color: brandColors.textSecondary }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                      <T>Preguntas y Respuestas</T>
                      {(questionsAndAnswers[offer.id]?.length ?? 0) > 0 && (
                        <Box
                          component="span"
                          sx={{ ml: 0.75, px: 1, py: 0.125, borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, backgroundColor: 'rgba(127,127,127,0.25)' }}
                        >
                          {questionsAndAnswers[offer.id].length}
                        </Box>
                      )}
                    </Typography>
                    {showQA[offer.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </Box>
                  {showQA[offer.id] && (
                  <>
                  {!questionsAndAnswers[offer.id]?.length && (
                    <Box sx={{ textAlign: 'center', py: 3 }}>
                      <ForumOutlinedIcon sx={{ fontSize: 32, color: brandColors.divider, mb: 1 }} />
                      <Typography variant="body2" sx={{ color: brandColors.textSecondary }}>
                        <T>Todavía no hay preguntas. ¡Sé el primero en preguntar!</T>
                      </Typography>
                    </Box>
                  )}
                  <List dense sx={{ p: 0, mt: 1 }}>
                    {questionsAndAnswers[offer.id]?.slice(0, showMoreQuestions[offer.id] ? undefined : 1).map((item) => (
                      <ListItem key={item.id} alignItems="flex-start" sx={{ p: 0, mb: 1.5 }}>
                        <Paper variant="outlined" sx={{ p: 1.75, width: '100%', borderRadius: 2, bgcolor: brandColors.backgroundPaper, borderColor: brandColors.divider }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Avatar src={item.profileImageUrl} alt={item.displayName} sx={{ width: 32, height: 32 }} />
                            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.displayName}</Typography>
                                {item.createdAt && (
                                  <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                    {formatDate(item.createdAt)}
                                  </Typography>
                                )}
                              </Box>
                              <Typography variant="body2" sx={{ mt: 0.25 }}>{item.question}</Typography>
                            </Box>
                          </Box>
                          {item.answers.map((answer) => (
                            <Box key={answer.id} sx={{ display: 'flex', gap: 1, mt: 1.5, pl: 2, borderLeft: `2px solid ${brandColors.divider}` }}>
                              <Avatar src={answer.profileImageUrl} alt={answer.displayName} sx={{ width: 26, height: 26 }} />
                              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
                                  <Typography variant="body2" sx={{ fontWeight: 600, color: brandColors.accent }}>{answer.displayName}</Typography>
                                  {answer.createdAt && (
                                    <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                      {formatDate(answer.createdAt)}
                                    </Typography>
                                  )}
                                </Box>
                                <Typography variant="body2" sx={{ mt: 0.25 }}>{answer.answer}</Typography>
                              </Box>
                            </Box>
                          ))}
                          {auth.currentUser?.uid === offer.uid && !item.answers.length && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5, pl: 2 }}>
                              <TextField
                                fullWidth
                                variant="standard"
                                size="small"
                                placeholder="Escribe tu respuesta..."
                                value={newAnswer[item.id] || ""}
                                onChange={(e) => setNewAnswer((prev) => ({ ...prev, [item.id]: e.target.value }))}
                                inputRef={(ref) => (answerInputRef.current[item.id] = ref)}
                              />
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleAnswerSubmit(item.id, offer.id)}
                                disabled={!newAnswer[item.id]?.trim()}
                              >
                                <SendIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          )}
                        </Paper>
                      </ListItem>
                    ))}
                  </List>

                  {(questionsAndAnswers[offer.id]?.length ?? 0) > 1 && (
                    <Button
                      size="small"
                      onClick={() => setShowMoreQuestions((prev) => ({ ...prev, [offer.id]: !prev[offer.id] }))}
                      sx={{ mt: 0, textTransform: 'none', fontSize: '0.8rem' }}
                    >
                      {showMoreQuestions[offer.id] ? <T>Mostrar menos</T> : <><T>Mostrar</T> {questionsAndAnswers[offer.id].length - 1} <T>más</T></>}
                    </Button>
                  )}

                   {userAuthenticated && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5 }}>
                        <TextField
                          fullWidth
                          placeholder="Escribe una pregunta..."
                          size="small"
                          value={newQuestion[offer.id] || ""}
                          onChange={(e) => setNewQuestion((prev) => ({ ...prev, [offer.id]: e.target.value }))}
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '999px', bgcolor: brandColors.inputBackground },
                            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                          }}
                        />
                        <IconButton
                          onClick={() => handleQuestionSubmit(offer.id)}
                          disabled={!newQuestion[offer.id]?.trim()}
                          sx={{
                            bgcolor: brandColors.primary,
                            color: '#fff',
                            '&:hover': { bgcolor: brandColors.primaryHover },
                            '&.Mui-disabled': { bgcolor: 'rgba(127,127,127,0.25)', color: brandColors.textSecondary },
                          }}
                        >
                          <SendIcon fontSize="small" />
                        </IconButton>
                    </Box>
                   )}
                  </>
                  )}
                </Box>
              </ListItem>
            ))}
          </List>
      );
    },
    [
      styles,
      aspectRatio,
      userLikes,
      userAuthenticated,
      loading,
      handleMeSirveClick,
      handleShareClick,
      handleFollowClick,
      handleOpenOptionsMenu,
      handleToggleSaveClick,
      savedOfferIds,
      isCompanyFollowed,
      handleOpenImageModal,
      handleQuestionSubmit,
      handleAnswerSubmit,
      newQuestion,
      newAnswer,
      showMoreQuestions,
      showQA,
      questionsAndAnswers,
      verifiedUids,
      officialUids,
      authorPhotos,
      auth.currentUser?.uid,
      handleLoadedMetadata,
      getDomainFromUrl,
      formatDate,
      setNewAnswer,
      setShowMoreQuestions,
      setNewQuestion,
      highlightedOfferId,
    ]
  );

  const renderContent = () => {
    // Sin resultados todavía pero quedan tandas por traer: se sigue buscando.
    if (filteredOffers.length === 0 && feedMayHaveMore(offersFeed)) {
      return <SkeletonLoader />;
    }

    if (hasSearched && filteredOffers.length === 0) {
      return <NoResults />;
    }

    if (!hasSearched && filteredOffers.length === 0 && rawOffers.length > 0) {
         return (
            <Paper sx={additionalStyles.noResults}>
                <LocalOfferIcon sx={additionalStyles.noResultsIcon} />
                <Typography variant="h6"><T>No hay coincidencias</T></Typography>
                <Typography color="textSecondary">
                    <T>No encontramos publicaciones con los filtros seleccionados.</T>
                </Typography>
                <Button variant="contained" color="primary" onClick={handleClearFilters}>
                    <T>Limpiar filtros</T>
                </Button>
             </Paper>
         );
    }

    if (filteredOffers.length > 0) {
        return (
          <>
            {renderOfferList(filteredOffers.slice(0, visibleOffersCount))}
            {(filteredOffers.length > visibleOffersCount || !offersFeed.exhausted) && (
              <Box ref={offersSentinelRef} sx={{ height: 1 }} />
            )}
          </>
        );
    }

    if (rawOffers.length === 0) {
         return (
            <Paper sx={additionalStyles.noResults}>
                <LocalOfferIcon sx={additionalStyles.noResultsIcon} />
                <Typography variant="h6"><T>Aún no hay publicaciones</T></Typography>
                <Typography color="textSecondary">
                    <T>Vuelve más tarde o sé el primero en publicar algo.</T>
                </Typography>
             </Paper>
         );
    }

    return null;
  };

  const handleClearFilters = () => {
    setSortBy("relevancia");
    setSelectedCategory("");
    setDiscountRange([0, 100]);
    setFilterMostSold(false);
    setFilterFollowedOnly(false);
    setFilterSavedOnly(false);
    setPriceRange({ min: "", max: "" });
  };

  const hasActiveFilters = Boolean(
    searchTerm.trim() || filterMostSold || filterFollowedOnly || filterSavedOnly || selectedCategory ||
    priceRange.min !== "" || priceRange.max !== "" ||
    discountRange[0] !== 0 || discountRange[1] !== 100
  );

  const filtersFields = (
    <>
      <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Ordenar por</T></Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <Select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <MenuItem value="relevancia"><T>Relevancia</T></MenuItem>
          <MenuItem value="recientes"><T>Más recientes</T></MenuItem>
          <MenuItem value="descuento"><T>Mayor descuento</T></MenuItem>
          <MenuItem value="interesa"><T>Más "Me interesa"</T></MenuItem>
        </Select>
      </FormControl>

      <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Categoría</T></Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <Select
          value={selectedCategory}
          displayEmpty
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <MenuItem value=""><T>Todas</T></MenuItem>
          {OFFER_CATEGORIES.map((c) => (
            <MenuItem key={c.id} value={c.id}><T>{c.label}</T></MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography sx={{ mb: 1 }}>
        <T>Descuento</T> {discountRange[0]}% - {discountRange[1]}%
      </Typography>
      <Slider
        value={discountRange}
        onChange={(e, newValue) => setDiscountRange(newValue)}
        valueLabelDisplay="auto"
        min={0}
        max={100}
        sx={{ mb: 3, color: brandColors.primary }}
      />

      <FormControlLabel
        sx={{ display: "flex", mb: 0.5 }}
        control={<Checkbox checked={filterMostSold} onChange={(e) => setFilterMostSold(e.target.checked)} />}
        label={<T>Más vendidos</T>}
      />
      <FormControlLabel
        sx={{ display: "flex", mb: 0.5 }}
        control={<Checkbox checked={filterFollowedOnly} onChange={(e) => setFilterFollowedOnly(e.target.checked)} />}
        label={<T>Solo tiendas que sigo</T>}
      />
      <FormControlLabel
        sx={{ display: "flex", mb: 2 }}
        control={<Checkbox checked={filterSavedOnly} onChange={(e) => setFilterSavedOnly(e.target.checked)} />}
        label={<T>Solo guardadas</T>}
      />

      <Typography sx={{ mb: 1 }}><T>Rango de precio</T></Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <TextField
          placeholder="Mín"
          type="number"
          size="small"
          fullWidth
          value={priceRange.min}
          onChange={(e) => setPriceRange((prev) => ({ ...prev, min: e.target.value }))}
        />
        <TextField
          placeholder="Máx"
          type="number"
          size="small"
          fullWidth
          value={priceRange.max}
          onChange={(e) => setPriceRange((prev) => ({ ...prev, max: e.target.value }))}
        />
      </Box>

      <Button
        fullWidth
        size="small"
        onClick={handleClearFilters}
        sx={{ mt: 3, textTransform: 'none' }}
      >
        <T>Limpiar filtros</T>
      </Button>
    </>
  );

  return (
    <Container maxWidth={false} disableGutters>
      {showTopBar && (
      <AppBar ref={appBarRef} position="fixed" elevation={0} sx={styles.topAppBar}>
        {!sidebarActive && (
        <Toolbar sx={styles.logoToolbar}>
          <CardMedia
            component="img"
            image={isDarkTheme ? DARK_LOGO_URL : isLightTheme ? LIGHT_LOGO_URL : logoSvg}
            title="Notiline"
            style={styles.media}
          />
        </Toolbar>
        )}
        <CustomToolbar
          isSearchOpen={isSearchOpen}
          onToggleSearch={toggleSearch}
          onOpenFilters={() => setFiltersOpen(true)}
          showSearchFilters={!isDesktop}
        />
        {!isDesktop && isSearchOpen && (
          <Box
            sx={{
              backgroundColor: sidebarActive ? "transparent" : barColors.background,
              px: 2,
              py: searchBarHidden ? 0 : 1,
              maxHeight: searchBarHidden ? 0 : 96,
              opacity: searchBarHidden ? 0 : 1,
              overflow: "hidden",
              transition: "max-height 0.28s ease, opacity 0.2s ease, padding 0.28s ease",
            }}
          >
            <Box sx={{ ...pageContentSx, display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                id="search-input"
                fullWidth
                autoFocus
                size="small"
                placeholder="Buscar por título"
                value={searchTerm}
                onChange={handleSearchChange}
                autoComplete="off"
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: <SearchIcon sx={{ mr: 1, color: brandColors.textSecondary }} />,
                  sx: {
                    color: brandColors.textPrimary,
                    backgroundColor: brandColors.inputBackground,
                    borderRadius: "999px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                  },
                }}
              />
            </Box>
          </Box>
        )}
      </AppBar>
      )}

      <Container maxWidth={false} disableGutters sx={{ width: "100%", mt: `${appBarHeight}px`, mb: 10 }}>
        {!isDesktop && (
          <Drawer
            anchor="bottom"
            open={filtersOpen}
            onClose={() => setFiltersOpen(false)}
            PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: "85vh", overflowX: "hidden" } }}
          >
            <Box sx={{ pt: 1.5, pb: 4, px: 3, width: "100%", maxWidth: `${PAGE_CONTENT_MAX_WIDTH}px`, mx: "auto", boxSizing: "border-box" }}>
              <SheetDragHandle onClose={() => setFiltersOpen(false)} />
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}><T>Filtros</T></Typography>
                <IconButton onClick={() => setFiltersOpen(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
              {filtersFields}
            </Box>
          </Drawer>
        )}
        <Box
          sx={{
            display: isDesktop ? "grid" : "block",
            gridTemplateColumns: isDesktop ? "260px 980px 260px" : undefined,
            columnGap: isDesktop ? 3 : 0,
            width: "100%",
            maxWidth: isDesktop ? "1568px" : `${PAGE_CONTENT_MAX_WIDTH}px`,
            mx: "auto",
            pt: isDesktop ? "20px" : 0,
            px: 2,
            boxSizing: "border-box",
          }}
        >
          {isDesktop && (
            <Paper
              variant="outlined"
              sx={{ p: 2.5, borderRadius: 3, position: "sticky", top: appBarHeight + 16, alignSelf: "start", maxHeight: `calc(100vh - ${appBarHeight + 16 + FILTER_PANEL_BOTTOM_GAP}px)`, ...filterPanelScrollSx }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}><T>Filtros</T></Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar por título"
                value={searchTerm}
                onChange={handleSearchChange}
                autoComplete="off"
                sx={{ mb: 3 }}
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: <SearchIcon sx={{ mr: 1, color: brandColors.textSecondary }} />,
                }}
              />
              {filtersFields}
            </Paper>
          )}
          <Box sx={{ minWidth: 0, pt: isDesktop ? 0 : 2 }}>
            {/* Eventos de Argentina: se ocultan si se detectó otro país. */}
            {!hasActiveFilters && (!detectedCountry || detectedCountry === "Argentina") && (
              <SaleEventsCountdown />
            )}
            {hasActiveFilters && (
              <Typography variant="h4" align="center" sx={{ mb: 4, fontWeight: "bold", color: "text.primary" }}>
                <T>Resultados</T>
              </Typography>
            )}
            {renderContent()}
            {!offersLoading && filteredOffers.length > 0 && (
              <Typography
                variant="caption"
                align="center"
                sx={{
                  display: "block",
                  color: brandColors.textSecondary,
                  mt: 4,
                  mb: 10,
                }}
              >
                © 2026 Dapur Tecnología - Notiline
              </Typography>
            )}
            {/* Botón flotante de wallet eliminado */}
          </Box>
          {isDesktop && <Box />}
        </Box>
      </Container>

      <Dialog
        open={openImageModal}
        onClose={handleCloseImageModal}
        PaperProps={{ sx: styles.imageModal }}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ p: 1, position: 'relative' }}>
           <IconButton
            aria-label={<T>cerrar</T>}
            onClick={handleCloseImageModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          {modalImages && modalImages.length > 0 ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '85vh' }}>
               <IconButton onClick={handlePreviousImage} sx={{ color: 'white', position: 'absolute', left: 10, zIndex: 1, backgroundColor: 'rgba(0,0,0,0.3)', '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)'} }}>
                <ArrowBackIosIcon />
              </IconButton>
              <CardMedia
                component="img"
                image={modalImages[currentImageIndex]}
                alt={`Imagen ${currentImageIndex + 1}`}
                sx={styles.imageModalImage}
              />
              <IconButton onClick={handleNextImage} sx={{ color: 'white', position: 'absolute', right: 10, zIndex: 1, backgroundColor: 'rgba(0,0,0,0.3)', '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)'} }}>
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>
          ) : (
            <Typography sx={{ color: 'white', textAlign: 'center' }}><T>No hay imágenes</T></Typography>
          )}
           {modalImages.length > 1 && (
             <Box sx={{ position: 'absolute', bottom: 15, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px' }}>
                {modalImages.map((_, index) => (
                    <Box key={index} sx={{
                        width: 8, height: 8, borderRadius: '50%',
                        backgroundColor: index === currentImageIndex ? 'white' : 'grey.600',
                        opacity: index === currentImageIndex ? 1 : 0.5
                    }}/>
                ))}
             </Box>
           )}
        </DialogContent>
      </Dialog>

      <BottomToolbar />

      <Menu
        anchorEl={optionsMenuAnchorEl}
        open={Boolean(optionsMenuAnchorEl)}
        onClose={handleOptionsMenuClose}
      >
        {optionsMenuOffer && isCompanyFollowed(optionsMenuOffer.uid) && (
          <MenuItem
            onClick={() => {
              handleUnfollowMenuClick(optionsMenuOffer);
              handleOptionsMenuClose();
            }}
          >
            <T>Dejar de seguir</T>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleReportOffer(optionsMenuOffer);
            handleOptionsMenuClose();
          }}
        >
          <T>Reportar</T>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleHideOffer(optionsMenuOffer);
            handleOptionsMenuClose();
          }}
        >
          <T>No me interesa</T>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleSimilarOffers(optionsMenuOffer);
            handleOptionsMenuClose();
          }}
        >
          <T>Más ofertas similares</T>
        </MenuItem>
        {optionsMenuOffer && auth.currentUser?.uid !== optionsMenuOffer.uid && (
          blockedIds.includes(optionsMenuOffer.uid) ? (
            <MenuItem
              onClick={() => {
                handleUnblockOfferUserClick(optionsMenuOffer);
                handleOptionsMenuClose();
              }}
            >
              <T>Desbloquear</T>
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                handleBlockOfferUserClick(optionsMenuOffer);
                handleOptionsMenuClose();
              }}
            >
              <T>Bloquear</T>
            </MenuItem>
          )
        )}
      </Menu>
    </Container>
  );
};

const styles = {
    cont: {},
    topAppBar: {
      backgroundColor: barColors.background,
      boxShadow: "none",
    },
    logoToolbar: {
      display: "flex",
      justifyContent: "center",
      padding: "8px 0",
    },
    media: {
      width: "130px",
      height: "auto",
      // Reserva el alto del logo (847x231) antes de que cargue: si no, el AppBar
      // crece al llegar la imagen, cambia appBarHeight y todo el feed se corre (CLS).
      aspectRatio: "847 / 231",
    },
    listItem: {
      display: "block",
      width: "100%",
      border: `1px solid ${brandColors.divider}`,
      backgroundColor: brandColors.backgroundPaper,
      borderRadius: "8px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      overflow: 'hidden',
      "&:hover": {
        boxShadow: "0 3px 8px rgba(0,0,0,0.4)",
      },
    },
    contUser: {
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      padding: "12px 16px",
      borderBottom: `1px solid ${brandColors.divider}`,
      backgroundColor: brandColors.backgroundDefault,
    },
    name: {
      color: brandColors.accent,
      fontSize: "1rem",
      fontWeight: "600",
      textDecoration: "none",
      transition: "color 0.2s ease",
      "&:hover": {
        opacity: 0.8,
      },
    },
    title: {
      fontSize: "1.1rem",
      marginBottom: "8px",
      color: brandColors.textPrimary,
      fontWeight: "600",
      lineHeight: "1.3",
    },
    description: {
      marginBottom: "12px",
      fontWeight: "400",
      color: brandColors.textSecondary,
      lineHeight: "1.5",
      fontSize: "0.9rem",
    },
    offer: {
      fontSize: "0.9rem",
      marginBottom: "8px",
      backgroundColor: brandColors.primary,
      color: "#ffffff",
      padding: "6px 10px",
      borderRadius: "4px",
      display: "inline-block",
      fontWeight: "500",
      mr: 1,
    },
    cupon: {},
    created: {
      fontSize: "0.75rem",
      color: brandColors.textSecondary,
      textAlign: 'right',
      mt: 1,
    },
    imageContainer: {
      position: "relative",
      width: "100%",
      borderRadius: feedPostMediaRadius,
      overflow: "hidden",
      backgroundColor: "#111",
      aspectRatio: '1/1',
    },
    mainImage: {
      display: 'block',
      width: "100%",
      height: "100%",
      objectFit: "contain",
      transition: "transform 0.3s ease",
      backgroundColor: "#222",
      "&:hover": {
        transform: "scale(1.03)",
      },
    },
    additionalImagesOverlay: {
      position: "absolute",
      bottom: "8px",
      right: "8px",
      backgroundColor: "rgba(0,0,0,0.6)",
      color: "white",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: '0.8rem',
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.8)",
      },
    },
    button: {
      textTransform: "none",
      borderRadius: "6px",
      padding: "8px 14px",
      fontWeight: "500",
      fontSize: "0.9rem",
      boxShadow: "none",
      transition: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
      "&:hover": {
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      },
    },
    actionButton: {
      backgroundColor: brandColors.primary,
      color: "white",
      "&:hover": {
        backgroundColor: brandColors.primaryHover,
      },
    },
    followButton: {},
    imageModal: {
      backgroundColor: "rgba(0,0,0,0.85)",
    },
    imageModalContent: {
      maxWidth: "90%",
      maxHeight: "85vh",
      position: "relative",
      backgroundColor: "transparent",
      padding: "0",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: 'center',
    },
    imageModalImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      width: 'auto',
      height: 'auto',
      objectFit: "contain",
      borderRadius: "4px",
    },
    imageModalNavigation: {},
    mediaSection: {
      width: { xs: "100%", md: "30%" },
      pr: { xs: 0, md: 2 },
    },
    contentSection: {
      width: { xs: "100%", md: "70%" },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
     noImage: {
        width: '100%',
        aspectRatio: '16/9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: brandColors.backgroundDefault,
        borderRadius: '6px',
        color: brandColors.textSecondary,
        fontSize: '0.9rem'
    }
};

const classes = {
    appBar: {
      top: "auto",
      bottom: 0,
      backgroundColor: barColors.background,
      color: barColors.text,
      borderTop: `1px solid ${barColors.border}`,
    },
    toolbar: {
      justifyContent: "space-around",
    },
    iconButton: {
      color: barColors.text,
    },
    icon: {
      color: barColors.text,
    },
    avatar: {
      width: 24,
      height: 24,
      border: `2.3px solid ${barColors.avatarBorder}`,
    },
};

const additionalStyles = {
    noResults: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px",
      textAlign: "center",
      marginTop: 0,
      backgroundColor: brandColors.backgroundPaper,
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      border: `1px solid ${brandColors.divider}`,
      gap: "16px",
    },
    noResultsIcon: {
      fontSize: "48px",
      color: "#bdbdbd",
    },
    scanArea: {},
    "@keyframes float": {},
    "@keyframes scan": {},
};

export default Home;